module.exports = __webpack_public_path__ + "img/88.eaf6cbcc.jpg";